import { render, staticRenderFns } from "./NewImageModal.vue?vue&type=template&id=446f6872&scoped=true&"
import script from "./NewImageModal.vue?vue&type=script&lang=js&"
export * from "./NewImageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446f6872",
  null
  
)

export default component.exports